module.exports = __webpack_public_path__ + "static/media/Balloon_1.f73c0bc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/balloon/Balloon_1.png
// module id = 1759
// module chunks = 3